import { datadogRum } from '@datadog/browser-rum';
import { useCallback } from 'react';
import { useAppliedFiltersContext } from '~/context/common/AppliedFiltersContext';
import { useSearchRequestId } from '~/context/srp/InventoryContext';
import type { AppliedFilters, MegaEventVehicle } from '~/contracts/common';

export default function useTrackSrpFiltersAndTileCounts() {
  const { appliedFilters, pageNumber } = useAppliedFiltersContext();
  const searchRequestId = useSearchRequestId();

  return useCallback(
    (vehicles: MegaEventVehicle[]) => {
      // Calculate aggregated counts for easier Datadog querying
      const onHoldCount = vehicles.filter(v => v.tileInfo?.isOnHold).length;
      const lockedCount = vehicles.filter(v => v.tileInfo?.isLocked).length;
      const preOrderCount = vehicles.filter(
        v => v.vehicleInventoryType === 2
      ).length;
      const filterCount = (
        Object.keys(appliedFilters) as Array<keyof AppliedFilters>
      ).filter(key => appliedFilters[key] != null).length;
      const termsCount = vehicles.filter(v => v.tileInfo?.hasTerms).length;

      datadogRum.addAction('srp-filters-and-tile-counts', {
        appliedFilters,
        counts: {
          activeFilters: filterCount,
          locked: lockedCount,
          onHold: onHoldCount,
          preOrder: preOrderCount,
          hasTerms: termsCount,
          totalUnavailable: onHoldCount + lockedCount,
          totalVehicles: vehicles.length,
          tilesWithTermsRate:
            vehicles.length > 0 ? termsCount / vehicles.length : 0
        },
        pageNumber,
        searchRequestId
      });
    },
    [appliedFilters, pageNumber, searchRequestId]
  );
}
